export default {"src":"/_next/static/media/placeholder-product-transparent.aaefc697.svg","height":1110,"width":1110};